import React from 'react'
import { Modal } from 'react-bootstrap';
import './Preview.css'

interface LottieAnimationProps {
    show: boolean,
    imagePath: string;
    onClose: () => void;
}

const FullScreenImagePreview: React.FC<LottieAnimationProps> = ({
    show,
    imagePath,
    onClose,
}) => {


    return (
        <Modal className='blurBackground' show={show} fullscreen={true} onHide={onClose}>
            <Modal.Header closeButton className='border-0' />
            <Modal.Body style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", overflow: "hidden" }}>
                <img src={imagePath} style={{ maxHeight: "70vh", maxWidth: "70vw", height: "100%", width: "100%", objectFit: "contain" }} alt='image-preview' />
            </Modal.Body>
        </Modal>
    );

}

export default FullScreenImagePreview